// NATIVE 
import * as React from 'react';



// INSTALLED 
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import { useNavigate } from 'react-router-dom';
import { Avatar, Card, Chip } from '@mui/material';
import Menu, { MenuProps } from '@mui/material/Menu';
import { styled, alpha  } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import TableContainer from '@mui/material/TableContainer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';





// CUSTOM 
import { getImageStore } from '../../store/files';
import { deepOrange } from '@mui/material/colors';
import MultipleSnackbars from '../MultipleSnackbars';
import { closeSessionGlobal, hasPemissions } from '../../commons/utils';
import { ModalSessionExpired } from '../generics/ModalSessionExpired';
import { getCompanyDataSelects, getCompanyStore,  storeDetailCompany } from '../../store/company';
import { paddingCardsTables, timeToClosedToast } from '../../commons/values';
import { SnackAlert } from '../SnackAlert';
import { AvatarTables } from '../AvatarTables';





  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: theme.palette.secondary.contrastText,
      fontSize: 15,
      fontWeight: 700
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 13,
    },
  }));

  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));





/**
 * TableCustomers component displays a table with company information and provides actions to view details, edit a company.
 *
 * @component
 * @example
 * return (
 *   <TableCustomers />
 * )
 *
 * @returns {JSX.Element} A React component that renders a table with company details and action buttons.
 *
 * @remarks
 * This component uses Redux for state management and React hooks for managing component state and side effects.
 *
 * @requires
 * - `useDispatch` from 'react-redux' for dispatching actions.
 * - `useSelector` from 'react-redux' for accessing the Redux store state.
 * - `useNavigate` from 'react-router-dom' for navigation.
 * - `MultipleSnackbars` for displaying alert messages.
 * - `Card`, `TableContainer`, `Paper`, `Table`, `TableHead`, `TableRow`, `TableBody`, `Avatar`, `Chip`, `Button`, `Menu`, `MenuItem`, `Divider` from '@mui/material' for UI components.
 * - `styled` from '@mui/system' for styling components.
 *
 * @state
 * - `logoUrl` (string): State to store the URL of the company logo.
 * - `logoUrlRz` (string): State to store the URL of the company business name logo.
 * - `openElem` (any): State to manage the currently opened element.
 * - `percentage` (number): State to manage the percentage of some process.
 * - `timeAlert` (number): State to manage the duration of alert messages.
 * - `messagesAlerts` (Array): State to store alert messages.
 * - `anchorEl` (HTMLElement | null): State to manage the anchor element for the menu.
 *
 * @methods
 * - `handleClick`: Handles the click event to open the menu.
 * - `handleClose`: Handles the event to close the menu.
 * - `getCompany`: Fetches company data from the store.
 * - `getLogoCompany`: Fetches the company logo.
 * - `getLogoRzCompany`: Fetches the company business name logo.
 * - `editCompany`: Dispatches an action to edit a company and navigates to the edit page.

 * - `detailCompany`: Dispatches an action to view company details and navigates to the detail page.
 *  */
export const TableCustomers = () => {


    // DISPATCH
   const dispatch = useDispatch();


   // NAVIGATION
   const navigate = useNavigate();


   // REDUX
   const  {  company }:any  = useSelector( (state:any) => state.company );


   // USE STATES
   const [logoUrl, setLogoUrl] = React.useState('');
   const [logoUrlRz, setLogoUrlRz] = React.useState('');

   const [openElem, setOpenElem] = React.useState(null);
   const [percentage, setPercentage] = React.useState(0);

   const [modalSessionExpired, setModalSessionExpired] = React.useState(false);


   const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
   const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);


   const [canEdit, setCanEdit]     = React.useState<boolean>(false);
   const [canDelete, setCanDelete]     = React.useState<boolean>(false);
   const [canRestore, setCanRestore]     = React.useState<boolean>(false);


   const [alert_snack, setAlertSnack] = React.useState(false);
   const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
   });


   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

   
   // USE EFFECT 
   React.useEffect(() => {
       getCompany();
   }, []);

   React.useEffect(() => {
      checkEdit()
    }, []);

    React.useEffect(() => {
        checkCanDelete()
    }, []);

    React.useEffect(() => {
      checkRestore()
    }, []);




   // CONST STYLES
   const StyledMenu = styled((props: MenuProps) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color:
        theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
      boxShadow:
        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': {
        padding: '7px 0',
      },
      '& .MuiMenuItem-root': {
        '& .MuiSvgIcon-root': {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        '&:active': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  }));



  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: 'wheat',
    padding: theme.spacing(8),
    textAlign: 'center'
  }));



   // CONST VALUE
   const open = Boolean(anchorEl);


    const handleClick = (elem:any) => (event:any) => {
      setAnchorEl(event.currentTarget);
      setOpenElem(elem);
    };


    const handleClose = () => {
      setAnchorEl(null);
      setOpenElem(null);
    };
  

    const getCompany = async() => {



      // modulo.tiponovedades                             nombre modulo     sub modulo    permission
      const havePermissions = await hasPemissions('modulo.configuracion', 'modulo.compania', 'view' );
  
      if( !havePermissions ){
  
        validateLsPermissions('No tienes pemisos para (listar) compañia.');
  
        return false;                    
          
      }

      const response = await dispatch( getCompanyStore() );


      const result = await validateResponse(response, ' ( Listar Compañia) ')

      if (!result) {
          return false;
      }



    }

    

    const editCompany = async(idCompany:string) => {


      setAnchorEl(null);
      setOpenElem(null);

      const havePermissions = await hasPemissions('modulo.configuracion', 'modulo.compania', 'edit' );
  
      if( !havePermissions ){
  
        validateLsPermissions('No tienes pemisos para (editar) compañia.');
  
        return false;                    
          
      }


      const response = await dispatch( storeDetailCompany(idCompany, setPercentage) );
      
      
      const result = await validateResponse(response, ' ( Ver Compañia) ')

      if (!result) {
          return false;
      }

      await dispatch( getCompanyDataSelects() );


      if (response.ok && response.ok) {
          navigate("/configuracion/compania/editar-compania");
      }

    }

    


    const detailCompany = async (idCompany:string) => {


      const havePermissions = await hasPemissions('modulo.configuracion', 'modulo.compania', 'view' );
  
      if( !havePermissions ){
  
        validateLsPermissions('No tienes pemisos para (ver) compañia.');
  
        return false;                    
          
      }


      const response = await dispatch( storeDetailCompany(idCompany, setPercentage) );

      
      const result = await validateResponse(response, ' ( Ver Compañia) ')

      if (!result) {
          return false;
      }


      if (response.ok && response.ok) {
          navigate("/configuracion/compania/detalle-compania");
      }
      
    }



    const validateLsPermissions = async(message:string) => {
    
        const errors:any = {
          msg: message,
          status: 'error'
        };
      
        await setMsgSnack(errors);
        await setAlertSnack(true);
      
      
    }
    
    
    const validateResponse = async(response:any, textActionConcat: string) => {
      
      
          if (  response.code == 401  ) {
            await localStorage.removeItem('lastSelectedQypht');
            await closeSessionGlobal();
            setModalSessionExpired(true);
            return false;
          }
  
        
          // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
          if (!response.ok && response.code == 403 ) { 
  
            const errors:any = {
              msg: response.errors[0]+' '+textActionConcat,
              status: 'error'
            };
          
            await setMsgSnack(errors);
            await setAlertSnack(true);
  
          
            return false;
  
          }
  
          
          // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
          if (!response.ok && response.code == 400 ) { 
  
              const errors:any = {
                msg: response.errors[0]+' '+textActionConcat,
                status: 'error'
              };
            
              await setMsgSnack(errors);
              await setAlertSnack(true);
  
            
              return false;
  
          }
  
          return true;
          
    }
  
  


   const checkEdit = async() => {
      
      const hasPermissionsEdit = await hasPemissions('modulo.configuracion', 'modulo.compania', 'edit' );
    
      if ( hasPermissionsEdit ) {
            setCanEdit(true);
      }
    }
  
  
    const checkCanDelete = async() => {
        
        const hasPermissionsDelete = await hasPemissions('modulo.configuracion', 'modulo.compania', 'delete' );
        
        if ( hasPermissionsDelete ) {
              setCanDelete(true);
        }
  
    }
  
  
    const checkRestore = async() => {
        
        const hasPermissionsRestore = await hasPemissions('modulo.configuracion', 'modulo.compania', 'restore' );
          
        if ( hasPermissionsRestore ) {
              setCanRestore(true);
        }
  
    }

    
  return (

    <>
    
     

      <ModalSessionExpired  open={modalSessionExpired}  />
                
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>

    {

    Object.keys(company).length > 0 && company.constructor === Object

          ?
          <>
          

          


          <Card
            sx={{
              display: 'flex',
              alignItems: 'center',
              p: 3,
              borderRadius: 2,
              boxShadow: 3,
              bgcolor: 'background.paper',
              marginTop: paddingCardsTables
            }}
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="right">Logo</StyledTableCell>
                    <StyledTableCell align="right">Nombre</StyledTableCell>
                    <StyledTableCell align="right">Dirección</StyledTableCell>
                    <StyledTableCell align="right">Razón Social</StyledTableCell>
                    <StyledTableCell align="right">Logo Razón Social</StyledTableCell>
                    <StyledTableCell align="right">Documento</StyledTableCell>
                    <StyledTableCell align="right">Email</StyledTableCell>
                    <StyledTableCell align="right">Estado</StyledTableCell>
                    <StyledTableCell align="right">Acciones</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    <StyledTableRow key={company.id}>
                      <StyledTableCell align="right">
                        <AvatarTables urlImage={company.logo_company} typeImage='company' />
                     </StyledTableCell>
                      <StyledTableCell component="th" scope="row">
                        {company.tradename}
                      </StyledTableCell>
                      <StyledTableCell align="right">{company.address_company}</StyledTableCell>
                      <StyledTableCell align="right">{company.business_name}</StyledTableCell>
                      <StyledTableCell align="right">
                         <AvatarTables urlImage={company.logo_bn_rz_company} typeImage='company' />
                      </StyledTableCell> 
                      
                      <StyledTableCell align="right">{company.number_document}</StyledTableCell>
                      <StyledTableCell align="right">{company.email}</StyledTableCell>
                      <StyledTableCell >
                        {
                          company.status ? <Chip size='small' label="Activo" sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700 }} /> : <Chip size='small' label="Inactivo" sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700 }} />
                        }
                      </StyledTableCell>
                      <StyledTableCell align="right" >
                            
      
                              
                      <div>
                        <Button
                          id="demo-customized-button"
                          aria-controls={open ? 'demo-customized-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? 'true' : undefined}
                          variant="text"
                          disableElevation
                          onClick={handleClick(company)}
                          endIcon={<KeyboardArrowDownIcon />}
                        >
                          Acciones
                        </Button>
                        <StyledMenu
                          id="demo-customized-menu"
                          MenuListProps={{
                            'aria-labelledby': 'demo-customized-button',
                          }}
                          anchorEl={anchorEl}
                          open={ openElem === company}
                          onClose={handleClose}
                        >
                          
                          {
                            (company.status) 
                              ? <>
                                <MenuItem onClick={ () => detailCompany(company.id) }  disableRipple>
                                <VisibilityIcon />
                                    Detalle 
                                </MenuItem>
                                {
                                   canEdit && 
                                      <> 
                                          <Divider sx={{ my: 0.5 }} />
                                          <MenuItem onClick={ () => editCompany(company.id) }  disableRipple>
                                            <EditIcon />
                                              Editar
                                          </MenuItem>
                                      </>
                                }
                              </>
                              :
                              ''
                          }
                          <Divider sx={{ my: 0.5 }} />
      
                        </StyledMenu>
                      </div> 
      
      
      
      
                      </StyledTableCell>
                    </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
          
        </>

          :
          <>
            <ModalSessionExpired  open={modalSessionExpired}  />
            <Div>{"No se ha creado la compañia ..."}</Div>
          </>

      }
    </>
      
  )

}
